import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { interval, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { selectVirtualEventData } from 'app/virtual-event/features/data/data.selectors';

@Component({
  selector: 'app-time-elapsed',
  templateUrl: './time-elapsed.component.html',
  styleUrls: ['./time-elapsed.component.scss']
})
export class TimeElapsedComponent implements OnInit {
  public event$: any = this.store.pipe(select(selectVirtualEventData));
  public timer$ = interval(1000).pipe(
    mergeMap(() => this.event$),
    mergeMap(this.updateTimer)
  );

  constructor(
    private store: Store<any>
  ) { }

  ngOnInit(): void {
  }

  updateTimer(event) {
    let seconds = Math.round(new Date().getTime()/1000) - event.currentStartTimeUnix;

    const hours = (seconds - seconds % 3600) / 3600;
    seconds = seconds - hours * 3600;

    const minutes = (seconds - seconds % 60) / 60;
    seconds = seconds - minutes * 60;

    let result = null;
    switch(event.runStatus) {
      case 0:
        result = { hours: 0, minutes: 0, seconds: 0 };
        break;
      case 1:
        result = { hours, minutes, seconds };
        break;
      case 2:
        result = { hours: 0, minutes: 0, seconds: 0 };
        break;
      default:
        result = { hours: 0, minutes: 0, seconds: 0 };
    }
    return of(result);
  }

}
